/** @jsx jsx */
import { gql } from '@apollo/client';
import { Label } from '@bottlebooks/gatsby-design-system';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ExhibitorStandBadge from '../../../../components/ExhibitorStandBadge';
import { Flex } from '@bottlebooks/gatsby-theme-base/src';

export default function ExhibitorStand({ exhibitor, ...rest }) {
  if (!exhibitor?.sessions) return null;
  return (
    <Label {...rest}>
      <Flex gap={1} sx={{ flexWrap: 'wrap' }}>
        {exhibitor.hasFreeShipping && (
          <ExhibitorStandBadge
            sx={{ display: 'inline-flex', marginBottom: 1 }}
            session="Free shipping"
          />
        )}
        {exhibitor.isTradeOnly && (
          <ExhibitorStandBadge
            sx={{ display: 'inline-flex', marginBottom: 1 }}
            session="Trade only"
          />
        )}
      </Flex>
    </Label>
  );
}

export const fragment = graphql`
  fragment ExhibitorStand on Exhibitor {
    stand {
      name: title
    }
  }
  fragment bb_ExhibitorStand_SingleRegistration on Bottlebooks_SingleRegistration {
    stand {
      name
    }
  }
`;

export const ExhibitorStandFragment = gql`
  fragment ExhibitorStand on Exhibitor {
    stand {
      name
    }
  }
  fragment ExhibitorStand_SingleRegistration on SingleRegistration {
    stand {
      name
    }
  }
`;
